import { render, staticRenderFns } from "./CustomerStories.vue?vue&type=template&id=629f312a&"
import script from "./CustomerStories.vue?vue&type=script&lang=js&"
export * from "./CustomerStories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports